import { render, staticRenderFns } from "./TopFormatList.vue?vue&type=template&id=732d67ce&scoped=true"
import script from "./TopFormatList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopFormatList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopFormatList.vue?vue&type=style&index=0&id=732d67ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d67ce",
  null
  
)

export default component.exports